import apiClient from './client';

export interface ServiceProvider {
  id: string;
  name: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateServiceProviderRequest {
  name: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  notes?: string;
}

export interface UpdateServiceProviderRequest {
  name?: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  notes?: string;
  isActive?: boolean;
}

export const serviceProvidersApi = {
  getAll: async (): Promise<ServiceProvider[]> => {
    const response = await apiClient.get('/service-providers');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getById: async (id: string): Promise<ServiceProvider> => {
    const response = await apiClient.get(`/service-providers/${id}`);
    return { ...response.data, id: response.data._id };
  },

  create: async (data: CreateServiceProviderRequest): Promise<ServiceProvider> => {
    const response = await apiClient.post('/service-providers', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: UpdateServiceProviderRequest): Promise<ServiceProvider> => {
    const response = await apiClient.put(`/service-providers/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/service-providers/${id}`);
  },
};
